import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './responsive-grid-plus.scss.js';
import '../../molecules/key-feature-card/index.js';

class ResponsiveGridPlus extends s {
    constructor() {
        super(...arguments);
        this.id = 'KeyFeaturesSection';
        this.sectionTitle = 'Key Features';
        this.showSectionTitle = false;
        this.keyFeatures = [];
    }
    get ariaLabelledBy() {
        if (!this.sectionTitle || this.sectionTitle.trim() === '') {
            return 'key-features-heading';
        }
        return this.sectionTitle
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '');
    }
    static getCardId(index) {
        return `key-feature-card-${index}`;
    }
    getColumnClasses() {
        const featuresCount = this.keyFeatures.length;
        switch (true) {
            case featuresCount === 1:
                return 'one-col';
            case featuresCount === 2:
                return 'two-cols';
            case featuresCount <= 6 && featuresCount !== 4:
                return 'three-cols';
            default:
                return 'four-cols';
        }
    }
    // eslint-disable-next-line class-methods-use-this
    generateKeyFeatureElement(keyFeature, colClass, index) {
        const cardId = ResponsiveGridPlus.getCardId(index);
        return $ `<div class="grid-element ${colClass}"><key-feature-card .cardId="${cardId}" .imageUrl="${keyFeature.imageUrl}" .imageAltText="${keyFeature.imageAltText}" .title="${keyFeature.title}" .body="${keyFeature.body}" .cta="${keyFeature.cta}" .index="${index}" ?isRtl="${keyFeature.isRightToLeftLanguage}"></key-feature-card></div>`;
    }
    generateSectionHeading() {
        const headingClass = this.showSectionTitle
            ? 'key-features-heading'
            : 'key-features-heading sr-only';
        return $ `<h2 id="${this.ariaLabelledBy}" class="${headingClass}">${o(this.sectionTitle)}</h2>`;
    }
    render() {
        const colClass = this.getColumnClasses();
        return $ `<section class="key-features-section" id="${this.id}" aria-labelledby="${this.ariaLabelledBy}">${this.generateSectionHeading()}<div class="key-features-grid responsive-grid-plus" role="group" aria-labelledby="${this.ariaLabelledBy}">${this.keyFeatures.map((keyFeature, index) => this.generateKeyFeatureElement(keyFeature, colClass, index))}</div></section>`;
    }
}
ResponsiveGridPlus.styles = css_248z;
__decorate([
    e({ type: String })
], ResponsiveGridPlus.prototype, "id", void 0);
__decorate([
    e({ type: String })
], ResponsiveGridPlus.prototype, "sectionTitle", void 0);
__decorate([
    e({ type: Boolean })
], ResponsiveGridPlus.prototype, "showSectionTitle", void 0);
__decorate([
    e({
        type: Array,
        reflect: true,
        converter: {
            fromAttribute: (value) => {
                if (!value)
                    return [];
                try {
                    const parsed = JSON.parse(value);
                    if (parsed &&
                        typeof parsed === 'object' &&
                        Array.isArray(parsed.keyFeature)) {
                        return parsed.keyFeature;
                    }
                    if (Array.isArray(parsed)) {
                        return parsed;
                    }
                    return [];
                }
                catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Error parsing keyFeatures JSON:', e);
                    return [];
                }
            },
            toAttribute: (value) => JSON.stringify(value),
        },
    })
], ResponsiveGridPlus.prototype, "keyFeatures", void 0);
customElements.define('responsive-grid-plus', ResponsiveGridPlus);

export { ResponsiveGridPlus };
